import React from 'react';
import Select from 'react-select';

import { useGetAllCardsQuery } from '../../../../redux/services/CardsApi';
import { Loading } from '../../../../components/Loading/Loading';
import { maskCard } from './helpers';

// API отдаёт bank объектом, хотя тип TCards описывает массив — поддерживаем оба
const bankName = (bank: unknown): string => {
  const value = Array.isArray(bank) ? bank[0] : bank;
  return (value as { name?: string } | undefined)?.name || '';
};

interface RequisitesSelectProps {
  value: number[];
  onChange: (ids: number[]) => void;
}

const selectStyles = {
  control: (provided: Record<string, unknown>) => ({
    ...provided,
    border: '2px solid #dbe0f2',
    borderRadius: '4px',
    boxShadow: 'none',
    '&:hover': { border: '2px solid #dbe0f2' },
  }),
  placeholder: (provided: Record<string, unknown>) => ({ ...provided, fontSize: '14px', color: '#8e95b0' }),
};

export const RequisitesSelect = ({ value, onChange }: RequisitesSelectProps) => {
  const { data, isLoading } = useGetAllCardsQuery({ page_size: 500 });
  if (isLoading) return <Loading />;
  const options = (data?.results || []).map((card) => ({
    value: card.id,
    label: `${bankName(card.bank)} ${maskCard(card.account_number)}${card.tag ? ` · ${card.tag}` : ''}`.trim(),
  }));
  return (
    <div style={{ marginBottom: '16px', width: '100%' }}>
      <div style={{ marginBottom: '4px', fontSize: '14px', color: 'black' }}>Реквизиты, на которые приходят уведомления</div>
      <Select
        isMulti
        options={options}
        value={options.filter((option) => value.includes(option.value))}
        styles={selectStyles}
        onChange={(selected) => onChange(selected ? selected.map((option) => option.value) : [])}
        placeholder={'Выберите реквизиты'}
        noOptionsMessage={() => 'Нет реквизитов'}
      />
      <div style={{ fontSize: '12px', color: '#8e95b0', marginTop: '4px' }}>
        Если ничего не выбрать — будут использоваться все ваши реквизиты банка-отправителя.
      </div>
    </div>
  );
};
